import React from "react";
import "@/styles/customStyles/DotsLoader.scss";
type DotsLoaderProps = {
  dots?: number;
  size?: number;
  color?: string;
};
const DotsLoader: React.FC<DotsLoaderProps> = ({
  dots = 3,
  size = 8,
  color = "#008493"
}) => {
  return <div className='loader' aria-label='Loading' role='status' data-sentry-component="DotsLoader" data-sentry-source-file="DotsLoader.tsx">
      {Array.from({
      length: dots
    }).map((_, index) => <div key={index} className='loader-item' style={{
      // CSS variable used for animation delay
      [("--item" as any)]: index + 1,
      width: size,
      height: size,
      background: color
    }} />)}
    </div>;
};
export default DotsLoader;